import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { getPlanDescriptionMessage } from './plan-description-message-map';
import styles from './plan-description.module.less';

/**
 * @param {object} props
 * @param {string} props.billingPlanId
 * @returns {React.JSX.Element}
 */
export const PlanDescription = ({ billingPlanId }) => {
  const planDescriptionText = getPlanDescriptionMessage(billingPlanId);

  return <Text className={styles['plan-description']} textType={TextType.Caption} value={planDescriptionText} />;
};
